<template>
    <div class="cg-search-condition-warp">
        <a-checkbox v-show="IsShowInterval" v-model="FindInInterval">
            区间
        </a-checkbox>
        
        <!--选择字段-->
        <a-select class="cg-search-col-select" v-model="SelectedCol">
            <a-select-option v-for="(col, index) in searchColList" 
                :key="index" :value="col.ColName">
                {{ col.ColTitle }}
            </a-select-option>
        </a-select>

        <!--区间搜索-->
        <template v-if="FindInInterval">
            <!--时间搜索-->
            <template v-if="IsDateSelect">
                <a-date-picker class="cg-box-body-search"
                    v-model="StartTime" 
                    :valueFormat="TimeFormat" 
                    showTime 
                    placeholder="开始时间" />
                <a-date-picker class="cg-box-body-search"
                    v-model="EndTime" 
                    :valueFormat="TimeFormat" 
                    showTime 
                    placeholder="结束时间" />
            </template>

            <!--数据集搜索-->
            <template v-else-if="IsDataTableCol && IsRenderDataTable">
                从
                <cg-edit-select class="cg-box-body-search" 
                    v-model="SearchContent" :colName="SelectedColInfo.ColName" 
                    :controlCfg="SelectedColInfo.ControlCfg" 
                />
                至
                <cg-edit-select class="cg-box-body-search" 
                    v-model="SearchContent" :colName="SelectedColInfo.ColName" 
                    :controlCfg="SelectedColInfo.ControlCfg" 
                />
            </template>

            <!--普通搜索-->
            <template v-else>
                从
                <a-input class="cg-box-body-search" v-model="StartValue" @keyup="OnKeyUp" />
                至
                <a-input class="cg-box-body-search" v-model="EndValue" @keyup="OnKeyUp" />
            </template>
        </template>

        <!--非区间搜索-->
        <template v-else>
            <!--搜索方式-->
            <a-select class="cg-search-interval-select" 
                v-model="SearchWay">
                <a-select-option v-for="(item, index) in WayOptions" 
                    :key="index" :value="item.Value">
                    {{ item.Desc }}
                </a-select-option>
            </a-select>

            <!--时间搜索-->
            <a-date-picker class="cg-box-body-search" v-if="IsDateSelect" 
                v-model="StartTime" 
                :valueFormat="TimeFormat" 
                showTime 
                placeholder="" 
            />

            <!--数据集搜索-->
            <cg-edit-select class="cg-box-body-search" v-else-if="IsDataTableCol && IsRenderDataTable" 
                v-model="SearchContent" :colName="SelectedColInfo.ColName" 
                :controlCfg="SelectedColInfo.ControlCfg" 
                @keyup="OnKeyUp"
            />

            <!--普通搜索-->
            <a-input class="cg-box-body-search" v-else v-model="SearchContent" @keyup="OnKeyUp" />
        </template>
    </div>
</template>
<script>

export default {
    props:{
        searchColList: {
            type: Array,
            default: []
        }
    },
    data() {

        return {
            FindInInterval: false, //是否是区间查找

            SelectedCol: "", //搜索字段
            SearchContent: "", //搜索内容
            SearchWay: "Include", //搜索方式
            
            WayOptions: [ //搜索方式选项
                { Value: "Include", Desc: "包含" },
                { Value: "Equal", Desc: "等于" }
            ],
            
            IsRenderDataTable: true, //是否渲染数据集
            IsShowInterval: false, //是否显示区间

            StartValue: "",
            EndValue: "",

            TimeFormat: "YYYY-MM-DD HH:mm:ss", //时间格式
            StartTime: "",
            EndTime: ""
        }
    },
    computed: {
        SelectedColInfo() {

            let _colInfo = this.searchColList.find(item => item.ColName === this.SelectedCol);

            if(_colInfo) {

                try {
                    _colInfo = JSON.parse(JSON.stringify(_colInfo));
                    _colInfo.ControlCfg["IsReadOnly"] = "0";
                    _colInfo["IsRequired"] = _colInfo.ControlCfg["IsRequired"] = "0";
                } catch(e) {}
            }

            return _colInfo;
        },
        IsDataTableCol() {

            let _colInfo = this.SelectedColInfo;

            return _colInfo && (_colInfo["ColControlName"] === "RadioButton" || _colInfo["ColControlName"] === "Select");
        },
        IsDateSelect() {

            let _colInfo = this.SelectedColInfo;

            return _colInfo && _colInfo["ColControlName"] === "DateSelect";
        }
    },
    watch: {
        SelectedCol() {

            let _colInfo = this.SelectedColInfo;

            if(_colInfo) {

                if(this.IsDataTableCol) {

                    this.WayOptions = [{ Value: "Equal", Desc: "等于" },{ Value: "NotEqual", Desc: "不等于" }];

                    this.IsRenderDataTable = false;

                    this.SearchWay = this.WayOptions[0].Value;

                    this.SearchContent = "";

                    this.$nextTick(()=>{ this.IsRenderDataTable = true; });
                }
                else {

                    let _wayOptions = [{ Value: "Include", Desc: "包含" },{ Value: "Equal", Desc: "等于" }];

                    //不是多字段
                    if(_colInfo.ColName.indexOf("/") < 0) { 
                        _wayOptions.push({ Value: "NotEqual", Desc: "不等于" });
                        _wayOptions.push({ Value: "NotInclude", Desc: "不包含" });
                    }

                    this.WayOptions = _wayOptions;

                    //之前是数据集字段
                    if(this.PrevIsDataTableCol) {

                        this.SearchWay = this.WayOptions[0].Value;
                        
                        this.SearchContent = "";
                    }
                }

                //不是多字段，显示区间checkbox
                this.IsShowInterval = _colInfo.ColName.indexOf("/") < 0;

                //日期选择，自动勾选区间
                this.FindInInterval = this.IsDateSelect;
            }

            this.PrevIsDataTableCol = this.IsDataTableCol;
        },
        FindInInterval() {
            this.StartValue = this.EndValue = "";
            this.StartTime = this.EndTime = "";
        },
        StartTime(curVal, oldVal) {
            
            if(!oldVal && curVal) {

                curVal = new Date(curVal);
                curVal.setHours(0,0,0,0);
                curVal = moment(curVal).format("YYYY-MM-DD HH:mm:ss");

                this.$nextTick(()=>{
                    this.StartTime = curVal;
                });
            }
        },
        EndTime(curVal, oldVal) {

            if(!oldVal && curVal) {

                curVal = new Date(curVal);
                curVal.setHours(0,0,0,0);
                curVal = moment(curVal).format("YYYY-MM-DD HH:mm:ss");

                this.$nextTick(()=>{
                    this.EndTime = curVal;
                });
            }
        }
    },
    created() {
        this.SelectFirstCol();
    },
    methods: {
        SelectFirstCol() {
            this.SelectedCol = this.searchColList[0] ? this.searchColList[0].ColName : "";
        },
        GetCondtion() {

            if(this.IsDateSelect) {
                this.SearchContent = this.StartTime;
                this.StartValue = this.StartTime;
                this.EndValue = this.EndTime;
            }

            return {
                SelectedCol: this.SelectedCol,
                StartSearchValue: this.StartValue || "",
                EndSearchValue: this.EndValue || "",
                SearchWay: this.SearchWay,
                FindInInterval: this.FindInInterval,
                SearchContent: this.SearchContent,
            };
        },
        SetCondtion(condition) {

            this.SelectedCol = condition.SelectedCol;
            this.StartValue = condition.StartSearchValue;
            this.EndValue = condition.EndSearchValue;
            this.SearchWay = condition.SearchWay;
            this.FindInInterval = condition.FindInInterval;
            this.SearchContent = condition.SearchContent;

            if(this.IsDateSelect) {
                this.StartTime = this.StartValue;
                this.EndTime = this.EndValue;
            }
        },
        OnKeyUp(event) {

            if(event.keyCode == 13) {
                this.$emit("search");
            }
        }
    }
}
</script>
<style>
.cg-search-condition-warp {
    display: inline-block;
}
.cg-search-condition-warp .cg-search-col-select {
    min-width: 180px;
    max-width: 180px;
}

.cg-search-condition-warp .cg-search-interval-select {
    min-width: 80px;
}

.cg-search-condition-warp .cg-box-body-search {
    width: 180px !important;
    min-width: 180px !important;
    display: inline-block;
}
</style>